import React, { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";

import { DataTrackMessage } from "../../../constants";
import useVideoContext from "../hooks/useVideoContext/useVideoContext";
import ModalEnterRoom from "../ModalEnterRoom";
import ConsultantSection from "./ConsultantSection";
import Header from "./Header";
import InventorySection from "./InventorySection";
import useStyles from "./styles";
import TabSection from "./TabSection";

const SurveyCall = () => {
  const classes = useStyles();

  const { dataTrack } = useVideoContext();

  const [roomSectionCollapsed, setRoomSectionCollapsed] = useState<boolean>(false);
  const [tabSectionCollapsed, setTabSectionCollapsed] = useState<boolean>(false);
  const [currentTab, setCurrentTab] = useState<number>(0);

  const beforeUnload = () => {
    dataTrack.send(DataTrackMessage.SHIPEEZI_REFRESH_SCREEN);
  };

  useEffect(() => {
    window.addEventListener("beforeunload", beforeUnload);
  }, []);

  const getConsultantSectionSize = () => {
    if (roomSectionCollapsed && tabSectionCollapsed) return 12;
    if (roomSectionCollapsed && !tabSectionCollapsed) return 9;

    return 5;
  };

  return (
    <div className={classes.container}>
      <ModalEnterRoom />
      <Grid container direction="row">
        <Header
          roomSectionCollapsed={roomSectionCollapsed}
          setRoomSectionCollapsed={setRoomSectionCollapsed}
          tabSectionCollapsed={tabSectionCollapsed}
          setTabSectionCollapsed={setTabSectionCollapsed}
          setCurrentTab={setCurrentTab}
        />
        <Grid container item xs={12} direction="row">
          <Grid item xs={getConsultantSectionSize()}>
            <ConsultantSection />
          </Grid>
          <InventorySection
            isCollapsed={roomSectionCollapsed}
            setIsCollapsed={setRoomSectionCollapsed}
          />
          <TabSection
            isCollapsed={tabSectionCollapsed}
            setIsCollapsed={setTabSectionCollapsed}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default SurveyCall;
